export const tabNames = ['Repositories', 'GitHub'];
